<template>
  <aside class="project-one-right-rail" qaid="project-one-right-rail">
    <project-one-right-rail-header
      :base-properties="baseProperties"
      :title="bp(currentRoute)"
      :is-back-button-enabled="backButtonEnabled"
      @on-backpress="goBack"
    />

    <section v-if="filteredModuleGroups" class="project-one-right-rail__body" qaid="project-one-right-rail-body">
      <!-- Displays information (name/msrp/eta) at the top of the right rail. -->
      <project-one-theme-info :base-properties="baseProperties" />

      <project-one-customize-choice
        v-for="choiceGroup in filteredModuleGroups"
        :key="choiceGroup.id"
        :base-properties="baseProperties"
        :choice="getSelectedChoice(choiceGroup)"
        :action-function="navigateIntoChoiceGroup"
        :parent-group-id="choiceGroup.id"
        :next-presentation-type="choiceGroup.presentationType"
        :is-selected="true"
        :has-multiple-choice="choiceGroup.choices.length > 1"
        :subheading="choiceGroup.description"
        @go-back="goBack"
      />
    </section>

    <project-one-right-rail-footer
      :base-properties="baseProperties"
      :button-text="bp('rightRailNextBtn')"
      :button-action="proceedToNextStep"
    />
  </aside>
</template>

<script>
import {mapActions, mapMutations, mapState} from 'vuex';
import ProjectOneCustomizeChoice from '@/projectOne/components/rightRail/components/ProjectOneCustomizeChoice';
import ProjectOneRightRailFooter from '@/projectOne/components/rightRail/components/ProjectOneRightRailFooter';
import ProjectOneRightRailHeader from '@/projectOne/components/rightRail/components/ProjectOneRightRailHeader';
import ProjectOneThemeInfo from '@/projectOne/components/rightRail/components/ProjectOneThemeInfo';

export default {
  components: {
    ProjectOneCustomizeChoice,
    ProjectOneRightRailFooter,
    ProjectOneRightRailHeader,
    ProjectOneThemeInfo,
  },

  data() {
    return {
      dialogVisible: false,
    };
  },

  computed: {
    ...mapState('projectOne', ['currentRoute', 'isThemeSelected', 'moduleGroups', 'selections']),

    backButtonEnabled() {
      return !!(this.currentRoute === 'paintTheme');
    },

    filteredModuleGroups() {
      let filteredGroups = null;
      if (this.moduleGroups) {
        filteredGroups = this.filterOutFontOptions([...this.moduleGroups]);
      }
      return filteredGroups;
    },
  },
  methods: {
    getSelectedChoice(choiceGroup) {
      let result = null;
      let selection = null;

      if (Array.isArray(this.selections)) {
        selection = this.selections.find((selection) => selection.groupId === choiceGroup.id);
      }

      if (choiceGroup?.choices && Array.isArray(choiceGroup.choices)) {
        // First attempt to retrieve choice using the selected choice id
        if (selection) result = choiceGroup.choices.find((choice) => choice.id === selection.choiceId);

        // If not match was found then attempt to get the choice using the default id
        if (!result) result = choiceGroup.choices.find((choice) => choice.id === choiceGroup.defaultChoiceId);

        // If neither the selected choice or the default choice found anything then default to the first choice in the array
        if (!result && choiceGroup.choices.length) result = choiceGroup.choices[0];
      }

      return result;
    },

    filterOutFontOptions(groups) {
      const fontOptionsGroupId = 36;
      const indexToRemove = groups.findIndex((group) => {
        return group.id === fontOptionsGroupId;
      });
      if (indexToRemove > -1) {
        groups.splice(indexToRemove, 1);
      }
      return groups;
    },

    navigateIntoChoiceGroup({groupId, choiceId, presentationType}) {
      if (groupId && presentationType) {
        let railConfig = {
          content: {
            groupId: groupId,
            choiceId: choiceId,
            presentationType: presentationType,
          },
        };

        this.pushToRailDataStack(railConfig);
      } else {
        console.warn('navigateIntoChoiceGroup function called without a groupId or presentationType');
      }
    },

    goBack() {
      if (this.currentRoute === 'paintTheme') {
        this.dialogVisible = false;
        this.setIsThemeSelected(false);
        this.setIsReselectingTheme(true);
        // using $router.push to 'paintTheme' again to clear the presetPK url param
        // allowing the user to select any preset including the one they previously selected
        this.$router.push({name: 'paintTheme'});
      }
    },

    ...mapActions('projectOne', ['proceedToNextStep']),
    ...mapMutations('projectOne', [
      'pushToRailDataStack',
      'setIsThemeSelected',
      'setIsReselectingTheme',
      'setSelections',
    ]),
  },
};
</script>
